export default "__VITE_ASSET__CQUBUzdM__"